import { render, staticRenderFns } from "./uploadPincodes.vue?vue&type=template&id=9bea93ae&scoped=true"
import script from "./uploadPincodes.vue?vue&type=script&lang=js"
export * from "./uploadPincodes.vue?vue&type=script&lang=js"
import style0 from "./uploadPincodes.vue?vue&type=style&index=0&id=9bea93ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bea93ae",
  null
  
)

export default component.exports